import moment from 'moment';
import Notification from '../UI/Notification/Notification';

const BirthdayNotificationComponent = ({ dateOfBirth }) =>
  moment(dateOfBirth, 'YYYY-MM-DD').isSame(moment().format('YYYY-MM-DD')) ? (
    <Notification status={'success'} message={'This client has birthday today'} />
  ) : null;

export default BirthdayNotificationComponent;
